export enum ProjectCode {
  DCS = 'DCS',
  LM = 'LM',
  HM = 'HM',
  MNP = 'MNP',
  AQUA = 'AQUA',
  RS = 'RS',
  HN = 'HN',
  ST = 'ST',
  FP = 'FP',
  PP = 'PP',
  PM = 'PM',
  YT = 'YT',
}

export const projectNameMap: Partial<Record<ProjectCode, string>> = {
  [ProjectCode.DCS]: '汪喵星球',
  [ProjectCode.LM]: '怪獸部落',
  [ProjectCode.MNP]: '超凝小姐',
  [ProjectCode.PP]: '日日貓砂',
  [ProjectCode.RS]: '日幸',
  [ProjectCode.AQUA]: '角落水族',
  [ProjectCode.HM]: 'HeroMama',
  [ProjectCode.PM]: '毛掌醫學',
  [ProjectCode.HN]: '海牛寵物',
  [ProjectCode.YT]: '虎留香',
}

export const companyNameOfProjectMap: Partial<Record<ProjectCode, string>> = {
  [ProjectCode.AQUA]: '海牛寵物',
  [ProjectCode.DCS]: '自力耕生股份',
  [ProjectCode.HM]: '飛輪寵物',
  [ProjectCode.HN]: '海牛寵物',
  [ProjectCode.LM]: '怪獸製造',
  [ProjectCode.MNP]: '海牛寵物',
  [ProjectCode.PM]: '飛輪寵物',
  [ProjectCode.PP]: '飛輪寵物',
  [ProjectCode.RS]: '誠安和生技',
  [ProjectCode.YT]: '新格食品 ',
}
